import React from 'react';
import { Link } from 'react-router-dom';
import CarteTerrains from '../components/CarteTerrains';

const pages = [
  {
    to: '/hall-of-fame',
    icon: 'bi-trophy-fill',
    label: 'Hall of Fame',
    desc: 'Les vainqueurs de chaque Saucismash, classés par nombre de victoires.',
    color: '#ffeb25',
  },
  {
    to: '/tournois',
    icon: 'bi-calendar-event-fill',
    label: 'Tournois',
    desc: 'Historique de tous les tournois Saucismash avec leurs résultats.',
    color: '#e10414',
  },
  {
    to: '/smasheurs',
    icon: 'bi-people-fill',
    label: 'Joueurs',
    desc: 'La liste des joueurs de la communauté et leurs statistiques.',
    color: '#ffeb25',
  },
  {
    to: '/trophees',
    icon: 'bi-award-fill',
    label: 'Trophées',
    desc: 'Les trophées et achievements débloqués par les joueurs.',
    color: '#e10414',
  },
  {
    to: '/anecdotes',
    icon: 'bi-body-text',
    label: 'Anecdotes',
    desc: 'Les histoires marquantes et moments mémorables de la commu.',
    color: '#ffeb25',
  },
];

const PageCard = ({ page }) => (
  <Link to={page.to} className="text-decoration-none">
    <div
      className="card h-100 border-0"
      style={{ background: '#2c2f33', transition: 'transform 0.2s, box-shadow 0.2s' }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.4)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div className="card-body d-flex align-items-start gap-3 p-3">
        <div
          style={{
            width: '44px',
            height: '44px',
            borderRadius: '10px',
            background: page.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <i
            className={`bi ${page.icon}`}
            style={{ fontSize: '1.3rem', color: page.color === '#ffeb25' ? '#212529' : '#fff' }}
          ></i>
        </div>
        <div>
          <h5 className="mb-1" style={{ color: '#fff', fontFamily: "'Fredoka One', cursive" }}>
            {page.label}
          </h5>
          <p className="mb-0 text-secondary" style={{ fontSize: '0.85rem' }}>
            {page.desc}
          </p>
        </div>
      </div>
    </div>
  </Link>
);

const Accueil = () => {
  return (
    <div>
      {/* Logo */}
      <div className="text-center" style={{ padding: '1.5rem 1rem 0.5rem' }}>
        <img
          src={require('../components/saucisse.png')}
          alt="Saucismash logo"
          style={{ width: '220px', height: '220px', objectFit: 'contain' }}
        />
      </div>

      {/* Hero banner */}
      <div className="hero-banner" style={{ padding: '1rem 1rem 1rem', margin: '0.75rem 2rem' }}>
        <h1 className="hero-title" style={{ fontSize: '2rem', marginBottom: '0.3rem' }}>SAUCISMASH</h1>
        <p style={{ fontSize: '0.95rem', fontWeight: '600', maxWidth: '560px', margin: '0 auto' }}>
          Weekly communautaire depuis 2019, la Saucismash est une institution de la commy smash lyon !
          Porte d'entrée pour les débutants, géré par les joueurs, pour les joueurs !
        </p>
      </div>

      {/* Infos pratiques */}
      <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2 my-4 px-3">
        <a
          href="https://www.google.com/maps/search/?api=1&query=Puzzle+Inn+Bar+retro+gaming+278+Rue+de+Crequi+69007+Lyon"
          target="_blank"
          rel="noopener noreferrer"
          className="badge fs-6 px-3 py-2 text-decoration-none"
          style={{ background: '#34A853', color: '#fff' }}
        >
          <i className="bi bi-geo-alt-fill me-2"></i>
          Puzzle Inn - Bar rétro gaming<br />278 Rue de Créqui, 69007 Lyon
        </a>
        <span className="badge text-bg-secondary fs-6 px-3 py-2">
          <i className="bi bi-calendar-week-fill me-2"></i>
          Tous les jeudis (en général)
        </span>
        <a
          href="https://discord.gg/XtYGwxC89r"
          target="_blank"
          rel="noopener noreferrer"
          className="badge fs-6 px-3 py-2 text-decoration-none"
          style={{ background: '#5865F2' }}
        >
          <i className="bi bi-discord me-2"></i>
          Discord SmashLyon pour toutes les infos
        </a>
      </div>

      {/* Sommaire */}
      <div className="container-xl px-3">
        <h2
          className="text-center mb-3"
          style={{ fontFamily: "'Fredoka One', cursive", fontSize: '1.8rem', color: '#ffeb25' }}
        >
          Sommaire
        </h2>

        {/* Ligne 1 : 3 cartes */}
        <div className="row g-3 mb-3 justify-content-center">
          {pages.slice(0, 3).map((page) => (
            <div key={page.to} className="col-12 col-sm-6 col-lg-4">
              <PageCard page={page} />
            </div>
          ))}
        </div>

        {/* Ligne 2 : 2 cartes centrées */}
        <div className="row g-3 mb-5 justify-content-center">
          {pages.slice(3).map((page) => (
            <div key={page.to} className="col-12 col-sm-6 col-lg-4">
              <PageCard page={page} />
            </div>
          ))}
        </div>

        {/* Crédits */}
        <p className="text-center text-secondary mb-5" style={{ fontSize: '0.8rem' }}>
          Site imaginé et créé par <strong className="text-light">LilMarty</strong>, puis repris et actualisé par{' '}
          <strong className="text-light">Aenor</strong>
        </p>

        {window.location.hostname === 'localhost' && (
          <div className="text-center mb-5">
            <CarteTerrains />
          </div>
        )}
      </div>
    </div>
  );
};

export default Accueil;
